<dx-popup
  [visible]="isVisible"
  [showTitle]="false"
  [width]="'90%'"
  [maxWidth]="420"
  [height]="'auto'"
  (onHiding)="closeModal()"
>
  <div *dxTemplate="let data of 'content'" class="modal-wrapper">
    <!-- Modal Header -->
    <div class="modal-header">
      <h4>Clone Holiday Calendar</h4>
      <button class="close-btn" (click)="closeModal()">&times;</button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <p class="modal-subtitle">
        Copy all configured holidays and weekend settings from an existing year
        to a new target year.
      </p>

      <!-- From Year Field (Readonly) -->
      <div class="form-group">
        <label>From Year </label>
        <dx-select-box
          [dataSource]="toYearList"
          [(ngModel)]="fromYear"
          valueExpr="year"
          displayExpr="year"
          stylingMode="outlined"
          [readOnly]="true"
          [searchEnabled]="true"
        >
        </dx-select-box>
      </div>

      <!-- Arrow Indicator -->
      <div class="direction-arrow">
        <i class="dx-icon-arrowdown"></i>
      </div>

      <!-- To Year Dropdown -->
      <div class="form-group">
        <label>To Year <span class="required">*</span></label>
        <dx-select-box
          [dataSource]="toYearList"
          valueExpr="year"
          displayExpr="year"
          [(ngModel)]="selectedToYear"
          placeholder="Select target year..."
          stylingMode="outlined"
          [searchEnabled]="true"
        >
        </dx-select-box>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <dx-button text="Cancel" class="themeButtonWhite" (click)="closeModal()"></dx-button>
      <dx-button
        text="Clone Calendar"
        type="default"
        class="themeButton"
        [disabled]="!selectedToYear"
        (onClick)="onCloneSubmit()"
      >
      </dx-button>
    </div>
  </div>
</dx-popup>
